import React from 'react';
import BaseMap, {mapDefaultProps, mapPropTypes} from '../base/Map';
import AbstractMap, {connectAbstractMap} from './AbstractMap';

/**
 * Mapa s pomocnými nástroji.
 */
class Map extends AbstractMap {

    static ToolType = BaseMap.ToolType;
    static ToolPosition = BaseMap.ToolPosition;
    static Tool = BaseMap.Tool;
    static EventType = BaseMap.EventType;
    static SymbolicDate = BaseMap.SymbolicDate;
    static DateFilterItem = BaseMap.DateFilterItem;

    static propTypes = {
        ...AbstractMap.propTypes,
        ...mapPropTypes
    };

    static defaultProps = {
        ...AbstractMap.defaultProps,
        ...mapDefaultProps
    };

    render() {
        return <BaseMap {...this.getBaseAbstractMapProps()}/>;
    }

}

export default connectAbstractMap(Map);
